import { render, staticRenderFns } from "./ConfigurableProduct.vue?vue&type=template&id=6362f113&scoped=true&"
import script from "./ConfigurableProduct.vue?vue&type=script&lang=ts&"
export * from "./ConfigurableProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurableProduct.vue?vue&type=style&index=0&id=6362f113&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6362f113",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductLabels: require('/usr/src/app/components/storyblok/ProductLabels.vue').default,LoadWhenVisible: require('/usr/src/app/components/storyblok/LoadWhenVisible.vue').default})
